// src/utils/axios.js

import axios from 'axios'
import apiConfig from '../config/api' // 引入 API 配置
import { showFailToast } from 'vant'

/** 后端偶发中文业务异常 → 客户端统一英文展示 */
const CLIENT_MSG_MAP = {
  '余额修改失败': 'Balance update failed',
  '用户不存在': 'User not found',
  'java.lang.IllegalStateException: 余额修改失败': 'Balance update failed',
  'java.lang.IllegalStateException: 用户不存在': 'User not found',
}

function toClientMsg(msg) {
  if (!msg) return msg
  const raw = String(msg).trim()
  if (CLIENT_MSG_MAP[raw]) return CLIENT_MSG_MAP[raw]
  if (raw.includes('余额修改失败')) return 'Balance update failed'
  if (raw.includes('用户不存在')) return 'User not found'
  return raw
}

// import { useRouter } from 'vue-router';
// 创建 axios 实例
const service = axios.create({
  baseURL: apiConfig.baseUrl, // 使用 API 配置中的 baseUrl
  timeout: 30000, // 请求超时时间
})
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

// 响应拦截器
service.interceptors.response.use(
  response => {

    const data = response.data
    console.log('response', data.code)
    // 成功状态码为 200
    // if (data.code === 200) {
    //   return data;
    // }

    // 其他非 200 状态码视为错误
    // showFailToast(data.message || '系统异常');

    // 非登录接口且 code != 200 时跳转登录页
    // if (!response.config.url.includes('/login')) {
    //   localStorage.removeItem('token'); // 清除 token

    //   console.log('跳转登录页');
    //   // router.push({ path: "/login" });
    //   window.$router.push('/login');

    // }
    if (data.code === 401) {
      window.$router.push('/login')
      localStorage.removeItem('token') // 清除 token
      return Promise.reject('Please login.')
    } else if (data.code === 500) {
      showFailToast(toClientMsg(data.msg))
      return Promise.reject(new Error(data.msg))
    } else if (data.code === 601) {
      showFailToast(toClientMsg(data.msg))
      return Promise.reject(data.msg || 'error')
    } else if (data.code !== 200) {
      showFailToast(toClientMsg(data.msg))
      return Promise.reject(data.msg || 'error')
    } else {
      return data
    }

    // return Promise.reject(new Error(data.message || 'Error'));
  },
  error => {
    // 网络错误等统一处理
    showFailToast('Network error, please try later')
    return Promise.reject(error)
  }
)

export default service
